import { autoinject } from 'aurelia-framework';
import { EnvironmentalConditionDto } from 'models/pen/EnvironmentalCondition';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class EnvironmentalConditionService extends BaseApiService<EnvironmentalConditionDto> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, EnvironmentalConditionDto);
  }
}
